import { Action } from '@ngrx/store';

export enum MachineActionTypes {
    MACHINE_EDIT = '[MACHINE] MachineEdit',
    MACHINE_EDITED = '[MACHINE] MachineEdited',
    MACHINE_ADD = '[MACHINE] MachineAdd',
    MACHINE_ADDED = '[MACHINE] MachineAdded',
    MACHINE_DELETE = '[MACHINE] MachineDelete',
    MACHINE_DELETED = '[MACHINE] MachineDeleted',
    MACHINE_GET_PAGE = '[MACHINE] MachineGetPage',
    MACHINE_PAGE_LOADED = '[MACHINE] MachinePageLoaded',
    MACHINE_GET_ALL = '[MACHINE] MachineGetAll',
    MACHINE_GET_TYPES = '[MACHINE] MachineGetTypes',
    MACHINE_TYPES_LOADED = '[MACHINE] MachineTypesLoaded',
    MACHINE_GET_SHIFTS = '[MACHINE] MachineGetShifts',
    MACHINE_SHIFTS_LOADED = '[MACHINE] MachineShiftsLoaded',
    MACHINE_GET_TECH_TYPES = '[MACHINE] MachineGetTechTypes',
    MACHINE_TECH_TYPES_LOADED = '[MACHINE] MachineTechTypesLoaded',
    MACHINE_ALL_LOADED = '[MACHINE] MachineAllloaded'
}

export class MachineAdd implements Action {
    readonly type = MachineActionTypes.MACHINE_ADD;
    constructor(public payload: any) {}
}

export class MachineEdit implements Action {
    readonly type = MachineActionTypes.MACHINE_EDIT;
    constructor(public payload: any) {}
}

export class MachineGetPage implements Action {
    readonly type = MachineActionTypes.MACHINE_GET_PAGE;
    constructor(public payload: any) {}
}

export class MachinePageLoaded implements Action {
    readonly type = MachineActionTypes.MACHINE_PAGE_LOADED;
    constructor(public payload: any) {}
}

export class MachineAdded implements Action {
    readonly type = MachineActionTypes.MACHINE_ADDED;
    constructor(public payload: any) {}
}

export class MachineEdited implements Action {
    readonly type = MachineActionTypes.MACHINE_EDITED;
    constructor(public payload: any) {}
}

export class MachineDelete implements Action {
    readonly type = MachineActionTypes.MACHINE_DELETE;
    constructor(public payload: any) {}
}

export class MachineDeleted implements Action {
    readonly type = MachineActionTypes.MACHINE_DELETED;
    constructor(public payload: any) {}
}

export class MachineGetAll implements Action {
    readonly type = MachineActionTypes.MACHINE_GET_ALL;
    constructor(public payload: any) {}
}

export class MachineGetTypes implements Action {
    readonly type = MachineActionTypes.MACHINE_GET_TYPES;
    constructor(public payload: any) {}
}

export class MachineTypesLoaded implements Action {
    readonly type = MachineActionTypes.MACHINE_TYPES_LOADED;
    constructor(public payload: any) {}
}

export class MachineGetShifts implements Action {
    readonly type = MachineActionTypes.MACHINE_GET_SHIFTS;
    constructor(public payload: any) {}
}

export class MachineShiftsLoaded implements Action {
    readonly type = MachineActionTypes.MACHINE_SHIFTS_LOADED;
    constructor(public payload: any) {}
}

export class MachineGetTechTypes implements Action {
    readonly type = MachineActionTypes.MACHINE_GET_TECH_TYPES;
    constructor(public payload: any) {}
}

export class MachineTechTypesLoaded implements Action {
    readonly type = MachineActionTypes.MACHINE_TECH_TYPES_LOADED;
    constructor(public payload: any) {}
}


export class MachineAllLoaded implements Action {
    readonly type = MachineActionTypes.MACHINE_ALL_LOADED;
    constructor(public payload: any) {}
}

export type MachineActions =
                | MachineAdd
                | MachineEdit
                | MachineGetPage
                | MachinePageLoaded
                | MachineAdded
                | MachineDeleted
                | MachineDelete 
                | MachineEdited
                | MachineGetAll
                | MachineAllLoaded
                | MachineGetTypes
                | MachineTypesLoaded
                | MachineGetTechTypes
                | MachineTechTypesLoaded
                | MachineGetShifts
                | MachineShiftsLoaded;